module.exports = __webpack_public_path__ + "img/gd-left-bottom.4c688272.svg";